import { render, staticRenderFns } from "./AdminRegister.vue?vue&type=template&id=686a113a"
import script from "./AdminRegister.vue?vue&type=script&lang=js"
export * from "./AdminRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports